import React, {Fragment} from 'react';
import ReactPlayer from 'react-player';
import {Video, Transformation} from 'cloudinary-react';
import styles from './Blog.css'

const Blog = () =>{
return(
    <Fragment>
    <div className="blog">
          <video width="100" height="100" controls autostart autoPlay 
          
          loop="true"
          src="Blog1.mp4" type="video/mp4" />
          <Transformation crop="pad" height="360" width="480" quality="70" duration="10"  />
      </div>
      <style>{'body { background-color: white; }'}</style>
        </Fragment>

);
}
export default Blog;